import { Guardian } from '@xaamin/guardian';

Guardian.define('empresa.intercambio', (user) => {
  return user.can('empresa.intercambio');
});